import { render } from "./shift-scheduling.vue?vue&type=template&id=ce80cb2a&scoped=true"
import script from "./shift-scheduling.vue?vue&type=script&lang=js"
export * from "./shift-scheduling.vue?vue&type=script&lang=js"

import "./shift-scheduling.vue?vue&type=style&index=0&id=ce80cb2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce80cb2a"]])

export default __exports__